/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Banner_User_CountInputs */

const en_homepage_banner_user_count = /** @type {(inputs: Homepage_Banner_User_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`50,000 +`)
};

const es_homepage_banner_user_count = /** @type {(inputs: Homepage_Banner_User_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`50,000 +`)
};

/**
* | output |
* | --- |
* | "50,000 +" |
*
* @param {Homepage_Banner_User_CountInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_banner_user_count = /** @type {((inputs?: Homepage_Banner_User_CountInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Banner_User_CountInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_banner_user_count(inputs)
	return en_homepage_banner_user_count(inputs)
});